import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { ZodIssue } from "zod"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

type LaunchTraceabilityDto = {
  ingestionId: string
  clientEmail: string
  file: File | null
}

export type LaunchTraceabilityResponse = {
  irCount: number
  supplierEmails: string[]
}
export function useLaunchTraceabilityMutation(
  options?: UseMutationOptions<
    LaunchTraceabilityResponse,
    AxiosError<ZodIssue | string>,
    LaunchTraceabilityDto
  >
) {
  return useMutation<
    LaunchTraceabilityResponse,
    AxiosError<ZodIssue | string>,
    LaunchTraceabilityDto
  >(
    async ({ ingestionId, file, clientEmail }: LaunchTraceabilityDto) => {
      const formData = new FormData()
      if (file) {
        formData.append("file", file)
      }
      formData.append("ingestionId", ingestionId.toString())
      formData.append("clientEmail", clientEmail)
      const response = await httpClient.post(
        "/admin/traceability/launch",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      return response.data
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(["ingestionsList"])
        options?.onSuccess?.(data, variables, context)
      },
    }
  )
}
